<template>
  <div class="filial-menu-table">
    <div class="filial-menu-table_search">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Поиск"
        outlined
        single-line
        hide-details
        clearable
      ></v-text-field>
    </div>

    <slot name="top-filter" />

    <div class="filial-menu-table_list">
      <loader v-if="loading" absolute transparent />
      <v-data-table
        v-else-if="items.length"
        fixed-header
        :search="search"
        :headers="headers"
        :items="menuItemsWithCategory"
        :items-per-page="-1"
        class="statistic-datatable headers-nowrap"
        :footer-props="{ disableItemsPerPage: true }"
        :options="tableOptions"
        group-by="categoryName"
      >
        <template v-slot:group.header="{ group, isOpen, toggle, headers }">
          <th :colspan="headers.length" class="filial-menu-table_group-row">
            <div class="filial-menu-table_group-title">
              {{ group }}
            </div>
          </th>
        </template>
        <template v-slot:item.image="{ item }">
          <v-img
            v-if="item.image"
            width="60"
            height="60"
            cover
            :src="item.image"
            class="filial-menu-table_menu-item-img"
          ></v-img>
        </template>

        <template v-slot:item.category="{ item }">
          <menu-item-category :item="item" />
        </template>

        <template v-slot:item.price="{ item }">
          {{ item.price | amountWithCurrency0 }}
        </template>

        <template v-slot:item.allFilials="{ item }">
          <span
            v-if="item.allFilials"
            class="color-green"
          ><font-awesome-icon
            icon="check"
          /></span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn
                  v-if="userCan(CRMPermission.EditFilialMenu)"
                  class="filial-menu-table_btn_delete"
                  :disabled="item.allFilials || selectedSource !== 'sushiset'"
                  depressed
                  color="pink"
                  small
                  @click="$emit('remove-item', item)"
                >
                  <font-awesome-icon icon="trash" />
                  Удалить
                </v-btn>
              </span>
            </template>
            <template v-if="item.allFilials">
              Обязательное блюдо нельзя удалить
            </template>
            <template v-else>
              Удалить блюдо из меню филиала
            </template>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
  import MenuItemCategory from '@/components/stat/menu/MenuItemCategory.vue'
  import Loader from '@/components/loader/Loader.vue'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'FilialMenuTable',
    emits: ['remove-item'],
    components: {
      Loader,
      MenuItemCategory,
    },
    props: {
      items: {
        type: Array,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: true,
      },
      selectedSource: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        search: null,
        tableOptions: {
          sortBy: ['cost'],
          sortDesc: [true],
        },
        headers: [
          { text: 'ID', value: 'id', align: 'center' },
          { text: 'Фото', value: 'image', align: 'right' },
          {
            text: 'Название блюда',
            value: 'name',
            align: 'left',
            sort: (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()),
          },
          { text: 'Категория', value: 'category', align: 'left' },
          { text: 'categoryName', value: 'categoryName', align: 'left' },

          { text: 'Цена блюда', value: 'price', align: 'center' },
          { text: 'Обязательное', value: 'allFilials', align: 'center' },
          { text: '', value: 'actions', align: 'left' },
        ],
      }
    },
    computed: {
      CRMPermission () {
        return CRMPermission
      },
      menuItemsWithCategory () {
        return this.items.map((item) => {
          item.categoryName = item.categories.length
            ? item.categories[0].name
            : 'Без категории'
          return item
        })
      },
    },
    methods: {
      groupItems (items, groupBy, groupDesc) {
        console.log({ items, groupBy, groupDesc })
        return [{ items }]
      },
    },
  }
</script>

<style scoped lang="less">
@import 'src/assets/styles/statistic.less';
.filial-menu-table {
  &_search {
    margin-bottom: 25px;
  }
  &_list {
    position: relative;
    min-height: 100px;
  }

  &_group {
    &-row {
      background: white;
      background: rgba(255, 157, 0, 0.11);
    }

    &-title {
      font-size: 22px;
      padding: 20px 0 20px 30px;
    }
  }

  &_menu-item-img {
    border-radius: 50%;
    //border: 2px solid #fff;
    margin: 5px;
    display: inline-block;
  }

  &_btn_delete {
    text-transform: none;

    &:not(.v-btn--disabled) {
      color: white;
    }
    svg {
      margin-right: 5px;
    }
  }
}
</style>
